import React, { Fragment, useContext } from "react";
import MuiFormGroup from "./mui-form-group";
import BSFormGroup from "./bs-form-group";
import FormContext from "../form-context";
import { IField } from "../../constants/model-interfaces";

function FormGroup(props: { fields: Array<IField> }) {
    const { theme } = useContext(FormContext);
    switch (theme.type) {
        case "mui":
            return <MuiFormGroup {...props} theme={theme} />;
        case "bootstrap":
            return <BSFormGroup {...props} theme={theme} />;
    }
    return <Fragment />;
}

export default FormGroup;
